<template>
  <div class="flex justify-between font-semibold" v-if="(props.item.count ?? 0) > 0">
    <template v-if="props.item.special && (item.count ?? 0) > 0">
      <div class="flex justify-start gap-3">
        <div v-if="props.version == 'mobile'">
          <ProductCircleProccent :item="props.item"></ProductCircleProccent>
        </div>
        <div class="text-2xl">{{ props.item.special.price }}₽</div>
        <div class="text-neutral-500 line-through decoration-red-700">{{ props.item.price }}₽</div>
      </div>
    </template>
    <template v-else>
      <div class="text-2xl">{{ props.item.price }}₽</div>
    </template>
  </div>
  <div v-else>
    <div class="text-xl text-gray-500">Товара нету в наличии...</div>
  </div>
</template>
<script lang="ts" setup>
import { type BookItem } from '@/types/book_item'
import ProductCircleProccent from '@/components/product/ProductCircleProccent.vue'

const props = defineProps<{
  item: BookItem
  version?: 'mobile'
}>()
</script>
